<template>
    <v-container>
      <PageHeader :title="title" :items="items" />
  
      <div class="row mt-0">
        <div class="col-12 pt-0">
          <div class="card">
            <div class="card-body pt-0">
  
              <div class="row mb-2">
                <!-- Search -->
                <div class="col-sm-12">
                  
                  <v-btn
                    @click="openModalFilterFolders()"
                    :disabled="loadingProjects"
                    color="primary"
                    :dark="false"
                    class="text-white float-right"
                  >
                    <i class="mdi mdi-filter me-1"></i>
                    Filtros
                  </v-btn>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <v-data-table
                    id="tabla-proyectos"
                    :page.sync="filters.page"
                    :headers="headers"
                    @page-count="pageCount"
                    :items="
                      filteredProjects && filteredProjects.projectlist
                        ? filteredProjects.projectlist
                        : []
                    "
                    item-key="code"
                    :items-per-page="filters.items"
                    class="elevation-1"
                    mobile-breakpoint="993"
                    hide-default-footer
                    :loading="loadingProjects"
                    @update:sort-by="updateSortBy"
                    @update:sort-desc="updateSortDesc"
                    no-data-text="Sin proyectos asignados"
                    loading-text="Cargando Proyectos... Espere Por favor"
                  >
                    <template v-slot:item.name="{ item }">
                      <div class="link-text text-left">
                        {{ item.name }}
                      </div>
                    </template>
  
                    <template v-slot:item.e1="{ item }">
                      <v-checkbox :id="'e1-' + item.code" v-model="item.e1" :name="'e1-' + item.code" @click="changeStage(1, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e2="{ item }">
                      <v-checkbox :id="'e2-' + item.code" v-model="item.e2" :name="'e2-' + item.code" @click="changeStage(2, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e3="{ item }">
                      <v-checkbox :id="'e3-' + item.code" v-model="item.e3" :name="'e3-' + item.code" @click="changeStage(3, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e4="{ item }">
                      <v-checkbox :id="'e4-' + item.code" v-model="item.e4" :name="'e4-' + item.code" @click="changeStage(4, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e5="{ item }">
                      <v-checkbox :id="'e5-' + item.code" v-model="item.e5" :name="'e5-' + item.code" @click="changeStage(5, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e6="{ item }">
                      <v-checkbox :id="'e6-' + item.code" v-model="item.e6" :name="'e6-' + item.code" @click="changeStage(6, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e7="{ item }">
                      <v-checkbox :id="'e7-' + item.code" v-model="item.e7" :name="'e7-' + item.code" @click="changeStage(7, item)">
                      </v-checkbox>
                    </template>
  
                    <template v-slot:item.e8="{ item }">
                      <v-checkbox :id="'e8-' + item.code" v-model="item.e8" :name="'e8-' + item.code" @click="changeStage(8, item)">
                      </v-checkbox>
                    </template>
                  </v-data-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-center">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <v-pagination
                      v-model="filters.page"
                      :length="
                        filteredProjects ? filteredProjects.projectpages : 1
                      "
                      :total-visible="8"
                    ></v-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <filters
        :modalAction="dialogFilterFolders"
        :closeModalFilterFolders="closeModalFilterFolders"
        @clearAllFilters="clearAllFilters"
        @searchFilters="searchFilters"
        :isProject="isProject"
        :isPresale="isPresale"
        :title="'Filtro de proyectos'"
      >
      </filters>
    </v-container>
  </template>
  <script>
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { mapActions, mapGetters } from "vuex";
  import { stageControlMethods } from "@/state/helpers";
  import { authUsuarioComputed } from "@/state/helpers";
  import { permiso } from "@/helpers/authservice/obtener-permisos";
  import Filters from "@/router/views/documents/maintaners/folders/Filters.vue";
  import roles from "@/mixins/roles";
  import { BUSINESS_UNITS } from "@/constants/common";
  import swal2 from "sweetalert2";
  export default {
    mixins: [roles],
    page: {
      title: "Control de Etapas",
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    },
    components: {
      PageHeader,
      Filters
    },
  
    data() {
      return {
        title: "Control de Etapas",
        items: [
          {
            text: "Mantenedores",
          },
          {
            text: "Proyectos",
          },
          {
            text: "Control de Etapas",
            active: true,
          }
        ],
        totalRows: 1,
        filters: {
          filter_stage: [],
          filter: null,
          filter_sap: true,
          page: 1,
          items: 10,
          sort_by: "created_at",
          sort_order: "desc",
          business_unit_code: ""
        },
        stages: [],
        debounce: null,
        debounceTime: 500,
        verTodosProyectos: false,
        headers: [
          {
            value: "code",
            text: "Código",
            sortable: true,
            align: "center",
            width: "20%",
          },
          {
            value: "name",
            text: "Proyecto",
            sortable: true,
            width: "30%",
          },
          {
            value: "e1",
            text: "E.1",
            sortable: false,
            align: "center",
          },
          {
            value: "e2",
            text: "E.2",
            sortable: false,
            align: "center",
          },
          {
            value: "e3",
            text: "E.3",
            sortable: false,
            align: "center",
          },
          {
            value: "e4",
            text: "E.4",
            sortable: false,
            align: "center",
          },
          {
            value: "e5",
            text: "E.5",
            sortable: false,
            align: "center",
          },
          {
            value: "e6",
            text: "E.6",
            sortable: false,
            align: "center",
          },
          {
            value: "e7",
            text: "E.7",
            sortable: false,
            align: "center",
          },
          {
            value: "e8",
            text: "E.8",
            sortable: false,
            align: "center",
          },
        ],
        dialogFilterFolders: false,
        isProject: false,
        isPresale: false,
      };
    },
    async mounted() {
      if (this.currentUserIsSuperAdmin) {
        await this.getBusinessUnits();
      } else {
        await this.getBusinessUnits({
          user_email: this.user.email,
        });
      }
      this.getStagesList();
  
      let verTodosProyectosPermiso = permiso.obtenerPermisos(
        this.user,
        "verTodosProyectos"
      );
      this.verTodosProyectos = false;
      if (
        verTodosProyectosPermiso != null &&
        verTodosProyectosPermiso != undefined
      ) {
        this.verTodosProyectos = true;
      }
      await this.getFilteredProjectsData(1, true);
    },
    methods: {
      ...stageControlMethods,
      ...mapActions({
        getFilteredProjects: "project/getFilteredProjects",
        cleanFilteredProjects: "project/cleanFilteredProjects",
        getBusinessUnits: "document/getBusinessUnits",
      }),
  
      async getFilteredProjectsData(page = 1, firstTime = false) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = await setTimeout(async function () {
          self.filters.page = page;
          let projects = await self.getFilteredProjects({
            ...self.filters,
            user: self.user.email,
            all_projects: self.verTodosProyectos,
            filter_name: self.filters.filter,
            filter_sap: self.filters.filter_sap ? true : undefined,
            filter_stage: self.filters.filter_stage.length
              ? self.filters.filter_stage.toString()
              : undefined,
            sort_by: self.filters.sort_by,
            sort_order: self.filters.sort_order,
          });
        }, self.debounceTime);
      },
  
      assignStages() {
        if(this.filteredProjects && this.filteredProjects.projectlist) {
          this.filteredProjects.projectlist.forEach(project => { 
            for (let i = 1; i <= 8; i++) { 
              project[`e${i}`] = false; 
            }
            project.sap_list.forEach(item => { 
              const code = item.sap_stage.code; 
              const num = parseInt(code.slice(-1)); 
              if (num >= 1 && num <= 8) { 
                project[`e${num}`] = true; 
              }
            });
          });
        }
      },
  
      getStagesList() {
        this.getStages()
          .then((res) => {
            this.stages = res;
          })
          .catch((error) => {
          });
      },
  
      changeStage(stage, item) {
        const status = item[`e${stage}`];
        const unit = BUSINESS_UNITS.find(unit => unit.name === item.business_unit);
        const selectedStage = this.stages.find(st => st.code === unit.code + stage);
        const body = {
          stage_id: selectedStage.id,
          project_id: item.id
        };
        if(status) {
          this.addStage(body)
            .then((res) => {
              if (res.detail == "Etapa asociada exitosamente") {
                return swal2.fire({
                  icon: "success",
                  title: "Excelente",
                  text: res.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((error) => {
              return swal2.fire({
                icon: "error",
                title: "Error",
                text: "Error desconocido",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
        else {
          this.removeStage(body)
            .then((res) => {
              if (res.detail == "Etapa removida exitosamente") {
                return swal2.fire({
                  icon: "success",
                  title: "Excelente",
                  text: res.detail,
                  position: "top-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((error) => {
              return swal2.fire({
                icon: "error",
                title: "Error",
                text: "Error desconocido",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      },
  
      async updateSortBy(sortBy) {
        if (sortBy) {
          this.filters.sort_by = sortBy;
          this.filters.sort_order = "asc";
          await this.getFilteredProjectsData();
        } else {
          this.filters.sort_by = "created_at";
          this.filters.sort_order = "desc";
          await this.getFilteredProjectsData();
        }
      },
  
      async updateSortDesc(sortDesc) {
        if (sortDesc) {
          this.filters.sort_order = "desc";
          await this.getFilteredProjectsData();
        }
      },
  
      pageCount(item) {
        if (this.search != "") {
          this.totalRows = item;
        }
      },
  
      openModalFilterFolders() {
        this.dialogFilterFolders = true;
      },
  
      closeModalFilterFolders() {
        this.dialogFilterFolders = false;
      },
  
      clearAllFilters() {
        this.filters.filter = null;
        if (this.businessUnits.length > 1) {
          this.filters.business_unit_code = null;
        }
        this.filters.items = 10;
        this.getFilteredProjectsData(1);
      },
  
      searchFilters(filters) {
        this.filters.filter = filters.filter;
        if (this.businessUnits.length > 1) {
          const unit = BUSINESS_UNITS.find(unit => unit.code === filters.business_unit);
          this.filters.business_unit_code = unit.name;
        }
        this.filters.items = filters.items;
        this.getFilteredProjectsData(1);
      },
      
    },
    computed: {
      ...authUsuarioComputed,
      ...mapGetters({
        filteredProjects: "project/filteredProjects",
        loadingProjects: "project/loading",
        businessUnits: "document/businessUnits",
      }),
    },
    watch: {
      filteredProjects: function (projects) {
        this.assignStages();
      },
      "filters.page": function (page) {
        this.getFilteredProjectsData(page);
      },
    },
  };
  </script>
  